import { makeAutoObservable } from "mobx";
import commonService from "../services/CommonService";
import systemStore from "./SystemStore";

export type ToastTypes = "info" | "success" | "warning" | "error";

export interface IToast {
  id?: number;
  message: string;
  type: "info" | "success" | "warning" | "error";
  duration?: number;
  tmo?: any;
  remove?: boolean;
}

class ToastStore {
  private _cnt = 0;
  private _suppressAccessDenied = false;

  constructor() {
    makeAutoObservable(this);
  }

  private _items: IToast[] = [];

  get items() {
    return this._items;
  }

  get suppressAccessDenied() {
    return this._suppressAccessDenied;
  }

  setSuppressAccessDenied(val: boolean) {
    this._suppressAccessDenied = val;
  }

  clearAll() {
    this.items.forEach((item) => {
      clearTimeout(item.tmo);
      this.removeToast(item);
    });
  }

  toggleHover(hover = false) {
    if (hover) {
      this.items.forEach((item) => {
        clearTimeout(item.tmo);
      });
    } else {
      this.items.forEach((item) => {
        item.tmo = setTimeout(() => {
          this.removeToast(item);
        }, item.duration);
      });
    }
  }

  async showError(
    message: string,
    error: any,
    duration = 5000,
    options?: {
      doNothingOn417?: boolean;
    }
  ) {
    const parsedMsg = commonService.parseErrorMessage(error);
    const errCode = commonService.getErrorStatusCode(error);
    if (errCode === 417) {
      systemStore.setHas417Error(parsedMsg, options?.doNothingOn417);
      return; //DO NOT SHOW
    }
    if (errCode === 408) {
      systemStore.setHas408Error(parsedMsg);
      return; //DO NOT SHOW
    }
    const text = `${message} ${parsedMsg}`;
    const html = `<strong>${message}</strong><br/>
    ${commonService.parseErrorMessage(error)}`;
    console.log(text);
    if (parsedMsg === "Access Denied" && this.suppressAccessDenied) {
      return; //DO NOTHING
    }
    return await this.showToast(html, "error", duration);
  }

  async showToast(message: string, type: ToastTypes = "info", duration = 5000) {
    this._cnt++;
    const tmo = setTimeout(() => {
      this.removeToast(item);
    }, duration);
    const item = {
      id: this._cnt,
      message: message,
      type: type,
      duration: duration,
      tmo: tmo,
    } as IToast;
    this._items.unshift(item);
    return item;
  }

  async removeToast(item: IToast) {
    this._items.forEach((t, i) => {
      if (t.id === item.id) {
        t.remove = true;
      }
    });
    setTimeout(async () => {
      await this._doRemoveToast(item);
    }, 1000);
  }

  private async _doRemoveToast(item: IToast) {
    let idx = -1;
    this._items.forEach((t, i) => {
      if (t.id === item.id) {
        idx = i;
        t.remove = true;
      }
    });
    if (idx > -1) {
      this._items.splice(idx, 1);
    }
  }
}

const toastStore = new ToastStore();
export default toastStore;
